import { useQuery } from "react-query";
import { userI } from "src/interfaces/Client";
import axios from "src/utils/axiosInstance";
import { baseUrl } from "src/utils/config";
import { getToken } from "src/utils/session";

const useClient = () =>
  useQuery<userI>(
    "User/me",
    async () =>
      (
        await axios.request({
          url: `${baseUrl}/me`,
          method: "get",
          headers: {
            "Cache-Control": "no-cache",
            Pragma: "no-cache",
            Expires: "0",
          },
        })
      ).data,
    {
      refetchInterval: 3600000, // one time per hour
      refetchOnWindowFocus: false,
      // Without a token the answer is a 401 and there is nothing to refresh
      // with; SessionGate sends the client to sign in without asking.
      enabled: Boolean(getToken()),
    },
  );

export default useClient;
